import styled from 'styled-components'
import theme from 'live/services/theme'

export const Container = styled.div`
    div.rc-tree-treenode {
        padding: 5px 0;
        display: flex;
        align-items: center;
        &:hover {
            background-color: ${theme['gray-lighter']};
            border-radius: 2px;
        }
    }

    .rc-tree-title {
        margin-left: 5px;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`
